(() => {
  const updateCartCount = (newCount) => {
    const cartBubble = document.querySelector('#cart-icon-bubble');
    if (!cartBubble) {
      console.warn('[SHOPPING BAG] No se encontró #cart-icon-bubble');
      return;
    }

    const countSpans = cartBubble.querySelectorAll('[data-cart-count]');
    if (countSpans.length === 0) {
      console.warn('[SHOPPING BAG] No se encontraron spans con [data-cart-count]');
      return;
    }

    countSpans.forEach((span) => {
      span.textContent = newCount;
    });
  };

  document.addEventListener('cart:updated', (event) => {
    const count = event.detail?.item_count;

    if (typeof count !== 'undefined') {
      updateCartCount(count);
    } else {
      console.warn('[SHOPPING BAG] No se encontró item_count en el detalle del evento');
    }
  });
})();
